import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Aperture"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5ZM20.88 10.605L16.5 13.14V4.21497C18.8489 5.57546 20.4583 7.92344 20.88 10.605ZM9 14.01V9.99L12 8.25L15 9.9825V14.0025L12 15.75L9 14.01ZM15 3.50998V8.24998L7.75504 4.06498C9.98419 2.86572 12.6177 2.66944 15 3.52498V3.50998ZM6.36 5.01002L10.5 7.38752L3 11.715C3.08675 9.0923 4.31387 6.63806 6.36 4.99502V5.01002ZM3.11996 13.3875L7.49996 10.8525V19.785C5.14918 18.4229 3.5395 16.0718 3.11996 13.3875ZM9 20.475V15.75L16.2525 19.935C14.9454 20.6374 13.4839 21.0034 12 21C10.9775 20.996 9.9631 20.8185 9 20.475ZM17.64 18.975L13.5 16.605L21 12.2775C20.9154 14.9028 19.6881 17.3602 17.64 19.005V18.975Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Aperture.vue"]]);
